import axiosInstance from "./instance";

// Get All Orders
const fetchOrders = async (page, statusType, deliveryType) => {
    const response = await axiosInstance.get('/orders', {
        params: {
            page,
            statusType,
            deliveryType,
        }
    });
    return response.data;
}

// For Dashbaord Graph

const fetchDashboardOrders = async () => {
    const response = await axiosInstance.get('/dashboard/orders');
    return response.data;
}

// Get Solo Order
const fetchOrder = async (orderId) => {
    const response = await axiosInstance.get(`/order`, {
        params: {
            // orderId: `${orderId}a`,
            orderId
        }
    });
    return response.data;
}

// Get All Riders
const fetchRiders = async () => {
    const response = await axiosInstance.get(`/oriders`, {
        params: {
            // orderId
        }
    });
    return response.data;
}

// Assign Order to Riders
const assignOrders = async (riderId, orders) => {

    console.log(riderId);

    console.log(orders);

    // const response = await axiosInstance.post(`/assignOrders`, riderId, orders);

    const response = await axiosInstance.post(`/assignOrders`, {
        riderId, orders
    });
    return response.data;
}

export { fetchOrders, fetchDashboardOrders, fetchOrder, fetchRiders, assignOrders };